import { PAYMENT_METHOD } from "../constant/constant";


const PaymentMethod = ({ type, className = "" }) => {
  const data = PAYMENT_METHOD[type?.toLowerCase()] || {
    label: type || "Unknown",
    icon: "/icons/default.svg",
    class: "bg-transparent text-gray-500",
  };

  return (
    <div
      className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-[14px] font-bold shadow-sm ${data.class} ${className}`}
    >
      <img
        src={data.icon}
        alt={data.label}
        className="w-7 h-7 object-contain"
      />
      <span>{data.label}</span>
    </div>
  );
};

export default PaymentMethod;
